import {getImageAssetUrl} from '@/_application/core/utils/common';
import {Image} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {ZALO_CHAT_LINK} from '@/lib/constants';
import {usePathname} from 'next/navigation';
import {isMobileDevice} from '@/_application/core/hooks/useIsMobileDevice';
import {PageType} from '@/_application/core/types';
import {useMemo} from 'react';
import {useAtomValue} from 'jotai';
import {currentPageTypeAtom} from '@/store/mobile-layout/mobile-layout';
import { PAGES_HIDE_CHAT_WIDGE, ROUTES_MOBILE_HIDE_CHAT_WIDGE } from '../constants/layout.constants';

const ZaloIcon = getImageAssetUrl('icons/zalo-icon.png');

const ChatWidget = ({iconSize = 40, currentPage}: {iconSize?: number; currentPage?: PageType | string}) => {
    const pathName = usePathname();
    const webViewNavigation = !!globalThis?.window?.ReactNativeWebView;
    const atomPageType = useAtomValue(currentPageTypeAtom);
    const resolvedPageType = atomPageType ?? currentPage;

    const isShow = useMemo(() => {
        if (!resolvedPageType || PAGES_HIDE_CHAT_WIDGE.has(resolvedPageType as PageType)) {
            return false;
        }
        const isPaymentMobile = isMobileDevice() && ROUTES_MOBILE_HIDE_CHAT_WIDGE.has(pathName);
        return !isPaymentMobile;
    }, [resolvedPageType, pathName]);

    if (!isShow || webViewNavigation) {
        return null;
    }

    return (
        <div className="fixed bottom-28 right-0 z-30 lg:bottom-10 lg:right-2">
            <Link href={ZALO_CHAT_LINK} target="_blank" aria-label="Zalo">
                <Image src={ZaloIcon} alt="zalo-chat-icon" width={iconSize} height={iconSize} />
            </Link>
        </div>
    );
};

export default ChatWidget;
